
import createIconComponent from '../utils/createIconComponent';
import { SVG_INFO_OUTLINED } from '../../../dist';
import React from 'react';
const InfoOutlinedIcon = createIconComponent({ content: SVG_INFO_OUTLINED, height: 24, width: 24 });
InfoOutlinedIcon.displayName = 'InfoOutlinedIcon';
export default InfoOutlinedIcon;
